import { actionSerializers } from './actionTriggerConfigs'
import { endpoints } from './endpoints'
import { fetchSerializers } from './fetchDataConfigs'
import { UserSerializer } from './userSerializer'

const dataConfigs = {
  endpoints,
  serializers: {
    user: UserSerializer,
    ...fetchSerializers,
    ...actionSerializers,
  },
}

export default dataConfigs
